import React, { useState } from 'react';
import { Lightbulb, ChevronRight } from 'lucide-react';
import inventions from '../data/uselessInventions.json';
import LikeButton from './LikeButton';
import ShareButton from './ShareButton';

const UselessInventions = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const generateNewInvention = () => {
    setCurrentIndex((prev) => (prev + 1) % inventions.inventions.length);
  };

  const invention = inventions.inventions[currentIndex];

  return (
    <div className="card hover-lift p-6 group">
      <div className="flex items-center space-x-2 mb-6">
        <div className="p-2 rounded-lg bg-gradient-to-br from-yellow-500/20 to-orange-500/20 group-hover:from-yellow-500/30 group-hover:to-orange-500/30 transition-colors">
          <Lightbulb className="h-6 w-6 text-yellow-400" />
        </div>
        <h3 className="text-xl font-semibold gradient-text">Useless Inventions</h3>
      </div>
      <div className="space-y-6">
        <div className="bg-gradient-to-br from-yellow-500/5 to-orange-500/5 rounded-lg p-4">
          <h4 className="text-lg font-semibold text-white mb-2">{invention.title}</h4>
          <p className="text-gray-300 leading-relaxed mb-4">{invention.description}</p>
          <div className="text-sm text-yellow-300">
            Problem: {invention.problem}
          </div>
          <div className="text-sm text-gray-400 mt-2">
            Inventor: {invention.inventor} ({invention.year})
          </div>
        </div>
        <div className="flex justify-between items-center text-sm">
          <div className="flex items-center space-x-2">
            <LikeButton type="invention" content={invention.title} />
            <ShareButton 
              title="Check out this useless invention!"
              text={`${invention.title}: ${invention.description} (Invented by ${invention.inventor}, ${invention.year})`}
            />
          </div>
          <button 
            onClick={generateNewInvention}
            className="text-yellow-400 hover:text-yellow-300 transition flex items-center space-x-1 group"
          >
            <span>Next Invention</span>
            <span className="transform group-hover:translate-x-1 transition-transform">→</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default UselessInventions;